module.exports = __webpack_public_path__ + "img/hr.9ed4b11c.png";